// extracted by mini-css-extract-plugin
export default {"button":"button-u9MZD","buttonLoading":"button-loading-qVHbc","primary":"primary-vsH8s","disabled":"disabled-Dtw0H","default":"default-TAZ95"};